import TreatmentsList from './_TreatmentsList';

export default TreatmentsList;
